/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
import { useState } from "react";
import {
  ButtonGroup,
  Card,
  Col,
  Container,
  FormSelect,
  Row,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Button, Input, ImageUpload } from "../../components";
import { DeleteSportRule } from "../../utilities/api/sports/indext";
import { RuleCard } from "./RuleCard";
import { toast } from "react-toastify";
import { messages } from "../../utilities/Messages";
import { VALID_IMAGE_TYPES } from "../../utilities/imageUtils";

const AddUpdateSports = (props: any) => {
  const {
    handleCreateUpdate,
    message,
    ruleCount,
    setRuleCount,
    rules,
    setRules,
    name,
    status,
    setStatus,
    sportName,
    setSportName,
    id,
    setImage,
    image,
    submitButton,
  } = props;
  const navigate = useNavigate();
  const [error, setError] = useState({
    name: "",
    image: "",
    rule: [],
  });

  const handleAdd = () => {
    setRuleCount(() => ruleCount + 1);
    setRules([...rules, { subject: "", description: "" }]);
  };

  const handleDelete = async (index: number) => {
    setRules(() => rules.filter((_: any, i: number) => i !== index));
    setRuleCount(() => ruleCount - 1);

    if (name === "Edit Sport") {
      let ruleid = rules.filter(
        (item: any, ind: number) => ind === index && item.ruleId
      );
      const result = await DeleteSportRule(id, ruleid[0].id);
      if (result.status === 200) {
        toast.success(result.data.message);
      } else {
        toast.error(result.response.data.message);
      }
    }
  };

  const handleCancel = () => {
    navigate("/sports");
  };

  const SPORT_MAX_SIZE = 100 * 1024; // 100KB

  const validate = () => {
    let validated =
      sportName != "" &&
      sportName?.length > 3 &&
      sportName.length < 30 &&
      rules.length &&
      rules[0].subject.length > 3 &&
      rules[0].subject.length < 200;

    if (!image || image === "") {
      return false;
    }
    if (typeof image === "string" && image.length > 0) {
      return validated;
    }
    const file = image instanceof File ? image : image?.[0];
    if (!file) return false;
    let _isValid = true;
    if (_isValid) {
      rules?.forEach?.((_rule: { subject: string | any[] }) => {
        if (!_rule?.subject) {
          _isValid = false;
        }
        if (_rule?.subject.length > 200) {
          _isValid = false;
        }
      });
    }

    return (
      validated &&
      VALID_IMAGE_TYPES.includes(file.type) &&
      file.size <= SPORT_MAX_SIZE &&
      _isValid
    );

  };

  let formData = new FormData();
  const getMessage = messages.sports;

  const onSubmit = () => {
    if (validate()) {
      rules.forEach((item: any, index: number) => {
        item?.ruleId && formData.append(`rules[${index}][ruleId]`, item.ruleId);
        item.subject.length &&
          formData.append(`rules[${index}][subject]`, item.subject);
        item.subject.length &&
          formData.append(`rules[${index}][description]`, item.description);
      });
      let payload: any = {
        name: sportName,
        isActive: `${status}`,
        image: image instanceof File ? image : image?.[0] || "",
      };
      for (let key in payload) {
        formData.append(key, payload[key]);
      }
      handleCreateUpdate(formData);
    } else {
      let message: any = [];
      rules?.map((_rule: any, index: any) => {
        message[index] = "";

        if (!_rule?.subject) {
          message[index] = getMessage.rules_isNotEmpty;
        }
        if (_rule?.subject.length > 200) {
          message[index] =
            getMessage.rules_length;
        }
      });
      let _error = {
        name:
          sportName == ""
            ? getMessage.name_isNotEmpty
            : sportName.length < 3 || sportName.length > 30
              ? getMessage.name_length
              : sportName.match(/^[a-zA-Z0-9\s\-.@(),/&#]*$/) == null
                ? getMessage.name_matches
                : "",
        image:
          typeof image === "string" && image.length > 0
            ? ""
            : image
              ? (() => {
                  const file = image instanceof File ? image : image?.[0];
                  if (!file) return getMessage.image_isNotEmpty;
                  if (!VALID_IMAGE_TYPES.includes(file.type)) return getMessage.invalid_file_format;
                  if (file.size > SPORT_MAX_SIZE) return getMessage.invalid_file_size;
                  return "";
                })()
              : getMessage.image_isNotEmpty,
        rule: message,
      };
      setError(_error);
    }
  };

  const handleSubjectChange = (index: number, value: string) => {
    setRules(() => {
      const newRules = [...rules];
      newRules[index].subject = value;
      return newRules;
    });
  };

  const ruleComponents = [];
  for (let i = 0; i < ruleCount; i++) {
    ruleComponents.push(
      <RuleCard
        key={i}
        ruleNumber={i + 1}
        subject={rules[i].subject}
        ruleError={error.rule[i]}
        setSubject={(value: any) => handleSubjectChange(i, value)}
        handleDelete={handleDelete}
      />
    );
  }
  return (
    <Container fluid className="g-0">
      <Card>
        <Card.Body>
          <Card.Title className="text-start">{name}</Card.Title>
          <Row>
            <Col lg={5}>
              <div className="text-start">
                <label htmlFor="sportsname" className="form-label">
                  Sports Name <small className="text-danger">*</small>
                </label>
                <Input
                  defaultValue={sportName}
                  onChange={(e: any) => setSportName(e.target.value)}
                  type="text"
                  placeholder="Enter Sports Name"
                  id="sportsname"
                  name="sportsname"
                  className="form-control"
                />
                <div className="custom-error-msg">{error?.name}</div>
              </div>
            </Col>
            <ImageUpload
              value={image}
              onChange={(img) => {
                setImage(img || null);
                setError((prev: any) => ({ ...prev, image: "" }));
              }}
              onError={(err) => setError((prev: any) => ({ ...prev, image: err }))}
              error={error?.image}
              maxSize={SPORT_MAX_SIZE}
              label="Upload Sport Image"
              required
              showWebcam={false}
              noWrapper
              uploadCol={5}
              previewCol={2}
              labelAs="h6"
            />
            {name === "Edit Sport" && (
              <Col lg={6} className="text-start">
                <label htmlFor="sportsname" className="form-label">
                  Status <small className="text-danger">*</small>
                </label>
                <FormSelect
                  defaultValue={status}
                  onChange={(e: any) => setStatus(e.target.value) as string}
                  name="sportstatus"
                  id="sportstatus"
                  className="form-control"
                >
                  <option>Select Sport Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </FormSelect>
              </Col>
            )}
          </Row>
          <p className="error-msg">{message}</p>
          {ruleComponents}

          <Row>
            <Col className="col mb-3 mt-3 text-end">
              <Button
                onClick={handleAdd}
                type="button"
                bname="Add Rule"
                name="addrule"
                id="addrule"
                className="btn btn-primary px-4 rounded-1"
              ></Button>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="text-end">
              <ButtonGroup>
                <Button
                  onClick={handleCancel}
                  type="button"
                  bname="Cancel"
                  name="cancel"
                  id="cancel"
                  className="btn btn-light rounded-1 me-3"
                ></Button>
                <Button
                  onClick={onSubmit}
                  type="button"
                  bname={
                    name === "Add Sport"
                      ? submitButton
                        ? "Submitting"
                        : "Submit"
                      : submitButton
                        ? "Updating"
                        : "Update"
                  }
                  name={name === "Add Sport" ? "Submit" : "Update"}
                  id={name === "Add Sport" ? "Submit" : "Update"}
                  className="btn btn-primary rounded-1"
                  disabled={submitButton}
                ></Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export { AddUpdateSports };
